module.exports = __webpack_public_path__ + "img/starNotFilled.788174a6.svg";